import React, { useEffect, useState} from 'react'

const PreviousDocumentsVans = (props) => {
    const [ renderArray, setRenderArray ] = useState([])


    var CryptoJS = require("crypto-js");
    async function postData(url = '', data = {}) {
        let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
        let originalText = bytes.toString(CryptoJS.enc.Utf8);
        const response = await fetch(url, {
            method: 'POST', 
            mode: 'cors',
            cache: 'no-cache',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Token ${originalText}`
            },
            body: JSON.stringify(data)
        });
        
        return response ? response.json() : console.log('no reponse')
    };

    useEffect( () => {
        let localArray = []

        if (props.vanDocs) {
            if (props.vanDocs.length > 0) {
                props.vanDocs.forEach( image => {
                    if (image.storageBool === true) {
                        if (image.imagesLink.includes('.pdf')) {
                            let pageString = 'pg_1/'
                            let begginingOfUrl = image.imagesLink.slice(0, 53)
                            let endOfUrlUrl = image.imagesLink.slice(53)
                            let endUrlString = begginingOfUrl.concat(pageString).concat(endOfUrlUrl)
                            let pngUrlPdf = endUrlString.replace(/.pdf/, '.png')
                            localArray.push(
                                <div className='imageComtainer'>
                                    <h3>{image.name}</h3>
                                    <img src={pngUrlPdf} alt="van document"/>
                                </div>
                            )
                        } else {
                            localArray.push(
                                <div className='imageComtainer'>
                                    <h3>{image.name}</h3>
                                    <img src={image.imagesLink} alt="van document"/>
                                </div>
                            )
                        }
                    }
                })
            }
        }

        setRenderArray(localArray)

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props])

    const returnFunction = () => {
        props.returnFunction()
    }

    return (
        <div className='vanPreviousDocuments'>
            <div className='renderArrayContainer'>
                {renderArray}
            </div>
            <button onClick={returnFunction}>Return</button>
        </div>
    )
}

export default PreviousDocumentsVans